export default __webpack_public_path__ + "static/media/antDesign.9bc8753a.svg";